import { storeService } from "@/services/storeService";
import { CommonParams, STORES_QUERY_KEYS } from "@/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetStoresMyCompany = (
  params?: CommonParams<{}> & {
    enabled?: boolean;
  }
) => {
  const { enabled = true, ...restParams } = params || {};

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery({
    queryKey: [STORES_QUERY_KEYS.GET_STORES_MY_COMPANY, restParams],
    queryFn: async ({ pageParam = 1 }) =>
      storeService.getStoresMyCompany({
        page: pageParam,
        limit: 20,
        ...restParams,
      }),
    getNextPageParam: (lastPage) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
    retry: 1,
    enabled,
  });

  const myCompanyStores = useMemo(() => {
    // convert to option [{label, value}]
    return (
      data?.pages
        .flatMap((page) => page.data)
        .map((store) => ({
          label: store.label,
          value: store.key,
        })) || []
    );
  }, [data]);

  return {
    myCompanyStores,
    fetchNextPage,
    hasNextPage,
    isFetching,
  };
};
